import React from 'react'
import Link from 'gatsby-link'

const IndexPage = () => (
  <div>
    <div id="content">
      <div className="post">
        <h2 className="title">
          <a href="#">Welcome to Dream Catcher Hunting Ranch</a>
        </h2>
        <div className="entry">
          <p>
            Come catch the dream of a lifetime here at Dream Catcher Hunting
            Ranch. You will be hunting in Central Utah at about 6000 ft. on the
            rolling hills covered with cedar, oak and cliff rose. The ranch is
            located about 140 miles south of the Salt Lake City Airport. Hunts
            are available with bow, muzzleloader or rifle. Depending on your
            hunting preference, they are done spot and stalk, on ATV's or in
            tree stands. Our experienced guides will do their best to customize
            the hunt to the hunter and give you the hunt you've always dreamed
            of.
          </p>
        </div>
      </div>
    </div>
    <div id="sidebar">
      <ul>
        <li>
          <h2>Give us a call today!</h2>
          <center>
            <h2 className="title">435.433.2057</h2>
          </center>
        </li>
      </ul>
    </div>
    <div style={{clear: 'both'}}>&nbsp;</div>
  </div>
)

export default IndexPage



// WEBPACK FOOTER //
// ./src/pages/index.js